var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaimuYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2639_30326)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2639_30326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 30,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3687 -0.36377H-0.368164V32.3635H28.3687V-0.36377Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2639_30326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0839 1.25H9.91797V12.4032H18.0839V1.25Z",
    fill: "#F7EE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1379 5.8208H1.21191V30.0876H25.1379V5.8208Z",
    fill: "#F4F185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8184 1.74951H4.01758V30.2507H23.8184V1.74951Z",
    fill: "#F4F185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2938 5.8208H20.1885V11.8468H26.2938V5.8208Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2275 7.84814H22.0645V14.3158H26.2275V7.84814Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8322 5.8208H1.70703V13.964H5.8322V5.8208Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85212 9.89258H1.70703V15.9186H3.85212V9.89258Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9536 9.89258H24.1484V30.0877H26.9536V9.89258Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4482 24.0615H22.168V30.0875H27.4482V24.0615Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2937 26.1787H20.0234V30.0874H26.2937V26.1787Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6333 28.2964H18.043V30.0879H25.6333V28.2964Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85212 23.8989H1.70703V31.3907H3.85212V23.8989Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99713 26.1787H1.21191V30.0874H5.99713V26.1787Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97806 28.1333H0.552734V30.0877H7.97806V28.1333Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4779 7.77539H16.0625V9.89263H24.4779V7.77539Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5586 7.77539H6.32812V9.89263H16.5586V7.77539Z",
    fill: "#FEF1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97078 5.82031H3.21973V11.8601H7.97078V5.82031Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0836 7.77539H11.9385V9.89263H14.0836V7.77539Z",
    fill: "#F7D360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03767 7.77539H-0.107422V30.0878H2.03767V7.77539Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.109 7.77539H25.9639V30.0878H28.109V7.77539Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2931 29.9248H1.70703V32.042H26.2931V29.9248Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.839 -0.205078H17.7139V3.86652H21.839V-0.205078Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2883 0.446289H6.16309V3.70356H10.2883V0.446289Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15269 1.74951H4.01758V3.70387H7.15269V1.74951Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50242 3.54102H2.8623V5.82112H5.50242V3.54102Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21952 5.80566H1.17285V7.84992H3.21952V5.80566Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8185 1.74951H19.5283V3.86674H23.8185V1.74951Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2879 3.8208H23.2412V5.8204H25.2879V3.8208Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6236 5.6582H24.4785V7.93831H26.6236V5.6582Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8387 -0.205078H6.16309V2.07502H21.8387V-0.205078Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0445 7.84814H14.0732V9.83105H16.0445V7.84814Z",
    fill: "#FEF1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29099 15.9185H6.36426V16.9262H9.29099V15.9185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36476 16.9282H5.34375V19.8328H6.36476V16.9282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3121 16.9282H9.29102V19.8328H10.3121V16.9282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2178 22.5981H15.1445V21.5903H12.2178V22.5981Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1445 21.5891H16.1656V19.6587H15.1445V21.5891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1973 21.5891H12.2183V19.6587H11.1973V21.5891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5379 16.8955H17.5479V20.6414H18.5379V16.8955Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0133 17.0586H18.8682V19.8273H21.0133V17.0586Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5132 16.9282H20.4922V19.8327H21.5132V16.9282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5281 18.8501H18.5381V20.6416H19.5281V18.8501Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.188 16.0815H17.7129V19.176H20.188V16.0815Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5097 17.916H18.4766V18.904H19.5097V17.916Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4922 16.9282H19.4912V17.9162H20.4922V16.9282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7127 16.8955H16.5576V19.8271H17.7127V16.8955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4931 15.9185H17.5664V16.9262H20.4931V15.9185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4859 20.6245H17.5361V21.6224H21.4859V20.6245Z",
    fill: "#F4A688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.518 19.6646H17.5479V20.6418H20.518V19.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28766 20.6416H5.33789V21.6395H9.28766V20.6416Z",
    fill: "#F4A688"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2639_30326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaimuYellow);
export default __webpack_public_path__ + "static/media/MaimuYellow.fc879d13487d90f41583cf0de227e4d3.svg";
export { ForwardRef as ReactComponent };